import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=34c6135e&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=34c6135e&prod&lang=scss"
import style1 from "./Confirmation.vue?vue&type=style&index=1&id=34c6135e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6135e",
  null
  
)

export default component.exports